module.exports = __webpack_public_path__ + "media/images/empty-5508c842d9231d4a99372847138719cd.png";